import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-items" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { class: "mt-2 d-flex w-100" }

import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed} from "vue";
import ChatSelectInput from "~/chat/vue/widget/form/fields/ChatSelectInput.vue";
import {createTimeSelect, numberToStringWithZero} from "~/chat/vue/widget/form/fields/ChatTimeInputHelper";


const __default__ = {
    name: "ChatTimeInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject} = useChatFormInput(props);

__expose(exposedObject);


let hourSelect = createTimeSelect(23);
let minuteSelect = createTimeSelect(59);

function getTimeSegment(index: number) {
    let value = props.modelValue?.split(":")[index];
    if (value) {
        value = parseInt(value);
    }
    if (!Number.isInteger(value)) {
        value = 0;
    }
    return numberToStringWithZero(value);
}

function createTimeComputed(index: number) {
    return computed({
        get: () => {
            return getTimeSegment(index);
        },
        set: (value: string) => {
            let newHour = index == 0 ? value : hour.value;
            let newMinutes = index == 1 ? value : minutes.value;
            emits("update:modelValue", `${newHour}:${newMinutes}:00`);
        }
    })
}


let hour = createTimeComputed(0);

let minutes = createTimeComputed(1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.field.descr), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ChatSelectInput, {
          modelValue: _unref(hour),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(hour) ? (hour).value = $event : hour = $event)),
          field: _unref(hourSelect),
          class: "time-select"
        }, null, 8, ["modelValue", "field"]),
        _createVNode(ChatSelectInput, {
          modelValue: _unref(minutes),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(minutes) ? (minutes).value = $event : minutes = $event)),
          field: _unref(minuteSelect),
          class: "time-select"
        }, null, 8, ["modelValue", "field"])
      ])
    ])
  ]))
}
}

})